<template lang="pug">
  .layout
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")

      v-card(flat)
        v-card-title.px-5
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="closeDialog()" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.primary500--text {{ shipping.name }}

        v-card-text.pa-0
          v-form(ref="form")

            v-row.px-5(align='center')
              v-col
                .s1.basic800--text {{ $t('enable_this_courier') }}
              v-col.shrink
                y-switch(:color="$vuetify.theme.themes[$theme].success400" v-model="shipping.enabled" @change="courier.channel === 'ys_malaysia' ? onUpdateCourierMy() : updateCourierId(shipping.enabled)")
            v-divider.basic300
            .options(v-if="shipping.enabled")
              v-row.px-5(align='center')
                v-col
                  .p1.basic800--text {{ $t('set_as_preferred') }}
                v-col.shrink
                  y-switch(:color="$vuetify.theme.themes[$theme].success400" v-model="isPreferred")
              v-divider.basic300
              .methods.px-5.mt-4
                template(v-if="courier.channel === 'ys_malaysia'")
                  .p1.basic800--text {{ $t('handover_method') }}
                  v-radio-group(v-model="selectedMethod" hide-details)
                    .pickup.mb-2(v-if="pickupObject.available")
                      v-radio(value='pickup' style="width:100%" color="textColorAccent")
                        template(v-slot:label)
                          div.s2.textColorDefault--text {{ $t('courier_pickup') }}
                      .details.ml-8.mt-n2
                        .c1.basic600--text {{ $t('courier_pickup_text') }}
                        .c2.basic600--text.mt-1(v-if="pickupObject.require_min_parcel") {{ $t('courier_pickup_min', { text: pickupObject.require_min_parcel } ) }}
                    .dropoff
                      v-radio(value='dropoff' style="width:100%" color="textColorAccent")
                        template(v-slot:label)
                          div.s2.textColorDefault--text {{ $t('drop_off') }}
                      .details.ml-8.mt-n2
                        .c1.basic600--text {{ $t('drop_off_text') }}

                template(v-else)
                  .p1.basic800--text {{ $t('select_parcel_delivery') }}
                  .delivery.mt-2(v-for="choice in shipping.choices" :key="choice.service_id")
                    y-checkbox.my-auto.mx-0.pa-0(v-model="shippingObject(choice).enabled" hide-details @change="onUpdateCourierId(shippingObject(choice))")
                      template(v-slot:label)
                        div.s2.my-auto {{ choice.service_type == 'regular' ? 'Regular' : 'Express' }}
                    .details.ml-8.mt-n2
                      .c1.basic600--text {{ $t('courier_pickup_text') }}
                      .c2.basic600--text.mt-1(v-if="pickupObject.require_min_parcel") {{ $t('courier_pickup_min', { text: pickupObject.require_min_parcel } ) }}

              v-divider.basic300.my-4

              .dropoff-point.px-5(v-if="shipping.required_dropoff_point && selectedMethod == 'dropoff'")
                .p1.basic800--text {{ $t('select_location') }}
                .c1.basic600--text {{ $t('select_location_text') }} {{ postcode }}
                  span.button-Aa-tiny.info500--text.clickable.ml-2(@click="newPostcode = postcode;showUpdatePostcodeDialog = true") {{ $t('change') }}
                v-select.mt-2(v-model="dropoffPoint" :item-text="getPointDisplay" :items="dropoffPoints" outlined dense background-color="basic200" placeholder="Select a drop-off location" :rules="rules.is_selected" return-object :loading="isFetchingPickupPoints" @change="onUpdateDropoffPoint()")
                  template(v-slot:append)
                    eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                  template(v-slot:item="{ index, item, attrs }")
                    v-layout
                      v-list-item-content
                        v-list-item-title.s1(:class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.company }}
                        v-list-item-subtitle.c1(:class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.point_name }}

                v-divider.basic300.my-4
    
    .modals
      y-dialog(fill-height fluid v-model="showUpdatePostcodeDialog" transition="fade-transition" scrollable persistent max-width="400px")
        v-card
          v-card-title(style="height:56px;")
            div.d-flex
            .h6.basic800--text {{ $t('change_postcode') }}
            v-spacer
            eva-icon.mb-n1(name="close-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="20" height="20" @click="showUpdatePostcodeDialog = false")
          v-divider.basic300
          v-card-text.py-3
            v-form(ref="postcodeform")
              v-text-field.mt-2(v-model="newPostcode" placeholder="Enter your postcode" dense outlined height="40" background-color="basic200" :rules="rules.not_empty" type="number")
            v-btn(block color='textColorAccent' dark depressed @click="changePostcode()")
              .button-AA-medium.basic100--text {{ $t('save_postcode') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'CourierMethod',
  props: ['open', 'courier', 'shipping'],
  data: () => ({
    isFetchingPickupPoints: false,
    postcode: null,
    newPostcode: null,
    dropoffPoints: [],
    dropoffPoint: null,
    showUpdatePostcodeDialog: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isPreferred: {
      get() {
        return this.courier.preferred === this.shipping.service_id
      },
      set(newValue) {
        if (newValue) {
          this.courier.preferred = this.shipping.service_id
        } else {
          this.courier.preferred = null
        }
      }
    },
    pickupObject () {
      const item = this.shipping.choices.filter(f => f.service_type === 'pickup')
      if (item.length === 0) {
        return { available: false }
      }
      return { ...item[0], data: item[0], switch: true, available: true }
    },
    dropoffObject () {
      const item = this.shipping.choices.filter(f => f.service_type === 'dropoff')
      if (item.length === 0) {
        return { available: false }
      }
      const data = item[0]
      if (this.dropoffPoint) {
        const data = item[0]
        data.dropoff_point = this.dropoffPoint
      }
      return { ...item[0], data: data, switch: true, available: true}
    },
    selectedMethod: {
      get () {
        let selectedShippings = this.courier.available_shipping.filter(f => f.enabled)
        let pickupShipping = selectedShippings.find(f => f.title === this.shipping.title && f.service_type === 'pickup')
        if (pickupShipping) {
          return 'pickup'
        }
        return 'dropoff'
      },
      set (newValue) {
        let shipping = this.courier.available_shipping.filter(f => f.title === this.shipping.title)
        if (shipping.length > 0) {
          shipping.forEach(o => {
            this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', false)
          })
        }
        if (newValue === 'pickup') {
          this.updateCourier(this.pickupObject)
        } else {
          this.updateCourier(this.dropoffObject)
        }
      }
    }
  },
  mounted () {
    if (this.shipping.required_dropoff_point) {
      this.postcode = this.courier.pickup_address.postcode
      let selectedShippings = this.courier.available_shipping.filter(f => f.enabled)
      const dropoff = selectedShippings.filter(f => f.service_id === this.dropoffObject.service_id).filter(f => f.service_type === this.dropoffObject.service_type)[0]
      if (dropoff && dropoff.dropoff_point) {
        this.dropoffPoint = dropoff.dropoff_point
        this.postcode = dropoff.dropoff_point.point_postcode
      }
      this.fetchPickupPoints()
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getPointDisplay (item) {
      return item.company + ' - ' + item.point_name
    },
    closeDialog () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.showModal = !this.showModal
    },
    fetchPickupPoints () {
      this.isFetchingPickupPoints = true
      this.$axios.post(`/shipping/yezzashipping/pgeon_points`, { postcode: this.postcode })
        .then((response) => {
          this.dropoffPoints = [ ...response.data.pgeon_points ]
        }).catch(() => {})
        .finally(() => { this.isFetchingPickupPoints = false })
    },
    changePostcode () {
      if (!this.$refs.postcodeform.validate()) {
        return
      }
      this.postcode = this.newPostcode
      this.showUpdatePostcodeDialog = false
      this.fetchPickupPoints()
    },
    onUpdateDropoffPoint () {
      let shipping = this.courier.available_shipping.filter(f => f.title === this.shipping.title)
      if (shipping.length > 0) {
        shipping.forEach(o => {
          this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', false)
        })
      }
      this.updateCourier(this.dropoffObject)
    },
    shippingObject(choice) {
      let selectedShippings = this.courier.available_shipping.filter(f => f.enabled)
      let selectedShipping = selectedShippings.filter(f => f.service_id === choice.service_id)
      let isSelected = selectedShipping.length > 0
      return { ...choice, enabled: isSelected, data: choice }
    },
    onUpdateCourierMy () {
      if (this.selectedMethod === 'pickup') {
        this.updateCourier(this.pickupObject)
      } else {
        this.updateCourier(this.dropoffObject)
      }
    },
    onUpdateCourierId (shipping) {
      let selectedShippings = this.courier.available_shipping.filter(f => f.enabled)
      let selectedShipping = selectedShippings.find(f => f.service_id === shipping.service_id)
      if (selectedShipping) {
        this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === shipping.service_id)], 'enabled', false)
      } else {
        this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === shipping.service_id)], 'enabled', true)
      }
      this.updateCourier(shipping)
    },
    updateCourierId (enabled) {
      if (!enabled) {
        this.courier.available_shipping.filter(f => f.title === this.shipping.title).forEach(o => {
          this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', false)
        })
      }
      this.updateCourier(this.shipping)
    },
    updateCourier (shipping) {
      this.$emit('update-enabled', shipping)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "enable_this_courier": "Enable this courier",
    "set_as_preferred": "Set as preferred shipping option",
    "handover_method": "Parcel handover method",
    "courier_pickup": "Courier pick up",
    "courier_pickup_text": "Courier rider will pick up your parcels from you",
    "courier_pickup_min": "(Requires min {text} parcels for pickup)",
    "drop_off": "Self drop off",
    "drop_off_text": "Drop off your parcel(s) at a branch near you",
    "select_location": "Select drop-off location",
    "select_location_text": "Drop-off location available for",
    "change_postcode": "Change postcode",
    "save_postcode": "Save postcode",
    "select_parcel_delivery": "Select parcel delivery method"
  },
  "id": {
    "enable_this_courier": "Aktifkan kurir ini",
    "set_as_preferred": "Tetapkan sebagai opsi pengiriman yang disukai",
    "handover_method": "Metode serah terima paket",
    "courier_pickup": "Jemputan kurir",
    "courier_pickup_text": "Pengemudi kurir akan mengambil paket kamu dari kamu",
    "courier_pickup_min": "(Memerlukan minimal {text} paket untuk pengambilan)",
    "drop_off": "Drop off sendiri",
    "drop_off_text": "Antarkan paket kamu di cabang terdekat",
    "select_location": "Pilih lokasi drop-off",
    "select_location_text": "Lokasi drop-off tersedia untuk",
    "change_postcode": "Ubah kode pos",
    "save_postcode": "Simpan kode pos",
    "select_parcel_delivery": "Pilih metode pengiriman paket"
  }
}
</i18n>
